const setItem = (key: string, value: string): void =>
  localStorage.setItem(key, value)

const getItem = (key: string, defaultValue = ''): string => {
  const data = localStorage.getItem(key)

  return data || defaultValue
}

const removeItem = (key: string): void => localStorage.removeItem(key)

const keyExists = (key: string): boolean => localStorage.getItem(key) !== null

const hasData = (key: string) => {
  const data = getItem(key)

  if (!data) {
    return false
  }

  return true
}

const removeLocalStorageItemsByPattern = (pattern: string) => {
  const regex = new RegExp(pattern)
  let i = 0

  while (i < localStorage.length) {
    const key: string = localStorage.key(i) || ''
    if (key && regex.test(key)) {
      localStorage.removeItem(key)
    } else {
      i += 1
    }
  }
}

export {
  setItem,
  getItem,
  removeItem,
  keyExists,
  hasData,
  removeLocalStorageItemsByPattern,
}
